export const toJSON = (data: string, defaultValue?: any) => {
    try {
        return typeof data === "string" && data.length > 0 ? JSON.parse(data) : defaultValue || {};
    } catch (error) {
        return defaultValue || {};
    }
};

export const jsonToStr = (data: any) => {
    try {
        return JSON.stringify(data);
    } catch (error) {
        return '';
    }
};

export const isEmpty = (val: any) => {
    return val === undefined || val === null || val === '' || val.length === 0;
};

export const formatPassword = (password: string, publicKey: string, encrypt: boolean) => {
    if(!encrypt) {
        return btoa(password);
    } else {
        return null;
    }
};

export const arrToStr = (arr: Array<string|number|null|undefined>, splitChar: string = "") => {
    let str = "";
    arr.forEach((item, index) => {
        if(item) {
            str +=  index !== arr.length - 1 ? item + splitChar : item;
        }
    });
    return str;
};

export const toStr = (...args: Array<string|number|null|undefined>) => arrToStr(args);
